import dayjs from 'lib/dayjs'

export const determineItemStatus = (
	status: string,
	releaseDate: string | null,
	contentCategory: string
): string => {
	const contentCategories = ['event', 'info', 'take_action']

	if (
		status === 'finished' &&
		(contentCategory as string) &&
		contentCategories.includes(contentCategory as string)
	) {
		return 'Expired'
	}
	if (
		releaseDate !== null &&
		status !== 'finished' &&
		status !== 'draft' &&
		dayjs.utc(releaseDate).local().isBefore(dayjs())
	) {
		return 'Published'
	}
	if (
		releaseDate !== null &&
		status !== 'finished' &&
		status !== 'draft' &&
		dayjs.utc(releaseDate).local().isAfter(dayjs())
	) {
		return 'Scheduled'
	}
	return status
}

export const shouldShowPublishedButton = (
	status: string,
	releaseDate: string | null,
	contentCategory: string
): boolean => {
	const itemStatus = determineItemStatus(
		status,
		releaseDate as string,
		contentCategory as string
	).toLowerCase()

	return itemStatus === 'published'
}
